angular
  .module('inhouseNoticeAdd')
  .component('inhouseNoticeAdd', {
    template: require('./inhouse-notice-add.template.html'),
    controller: ['$rootScope', '$scope', '$resource', '$route', '$location', '$window', '$translate', 'AuthService', 'envService', 'Upload',
      function inhouseNoticeAddViewController($rootScope, $scope, $resource, $route, $location, $window, $translate, AuthService, envService, Upload) {
        $rootScope.mainmenu = 'notices';
        $rootScope.menu = 'inhouseNoticeList';
        const APIURL = envService.read('apiUrl'); // eslint-disable-line
        if (!AuthService.isAuthenticated()) {
          $location.path('/login');
          return;
        }
        this.notice = { TITLE: '', CONT: '', medias: [], TOPYN: false };
        this.submit = () => {
          for (let idx = 0; idx < this.notice.medias.length; idx += 1) {
            const url = this.notice.medias[idx];
            if (url.length < 1) {
              alert($translate.instant('이미지를 업로드해주세요.'));
              return;
            }
          }
          this.notice.URLS = this.notice.medias;
          if (!this.notice.TITLE || this.notice.TITLE.length < 1) {
            alert($translate.instant('제목을 입력해주세요.'));
            return;
          }
          if (!this.notice.CONT || this.notice.CONT.length < 1) {
            alert($translate.instant('내용을 입력해주세요.'));
            return;
          }
          if (this.notice.TOPYN) {
            this.notice.TOPYN = 'Y';
          } else {
            this.notice.TOPYN = 'N';
          }
          this.notice.MAIN_POPUP_YN = (this.notice.MAIN_POPUP_YN) ? 'Y' : 'N';
          $resource(`${APIURL}/admin/inhouseNotice`).save(this.notice).$promise
            .then(() => {
              $location.path('/inhouse/notice');
            })
            .catch((err) => {
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
        };

        this.upload = (files, index) => {
          if (files && files.length) {
            const file = files[0];
            Upload.upload({
              url: `${APIURL}/admin/file/inhouseNotice`,
              file,
            }).progress(() => {
            }).success((data, status, headers, config) => { // eslint-disable-line no-unused-vars
              this.notice.medias[index] = data.url;
            });
          }
        };
        this.remove = (url) => {
          var URLS = [];
          for (let idx = 0; idx < this.notice.medias.length; idx += 1) {
            var item = this.notice.medias[idx];
            if (item == url) {
              continue;
            }
            URLS.push(item);
          }
          this.notice.medias = URLS;
        };

        this.add = () => {
          this.notice.medias.push('');
        };
      },
    ],
  });



// WEBPACK FOOTER //
// ./src/app/boards/inhouse-notice/inhouse-notice-add/inhouse-notice-add.component.js